<div class="relative" (click)="$event.stopPropagation()">
  <button
    type="button"
    (click)="toggleMenu($event)"
    class="flex h-9 items-center gap-1 rounded-lg px-2 text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-white/5"
    [attr.aria-label]="languageAriaLabel()"
    [attr.aria-expanded]="menuOpen()"
    aria-haspopup="listbox"
  >
    <span class="text-base leading-none select-none" aria-hidden="true">{{
      locale.currentLocaleOption().flag
    }}</span>
    <span class="text-xs font-medium">{{ locale.currentLocaleOption().shortLabel }}</span>
  </button>
  @if (menuOpen()) {
    <ul
      role="listbox"
      class="absolute right-0 top-full z-50 mt-1 min-w-44 rounded-xl border border-slate-200/80 bg-white py-1 shadow-xl dark:border-white/10 dark:bg-[#1a1f2e]"
    >
      @for (option of locale.supportedLocales; track option.id) {
        <li role="option" [attr.aria-selected]="locale.locale() === option.id">
          <button
            type="button"
            (click)="selectLocale(option.id)"
            class="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm hover:bg-slate-50 dark:hover:bg-white/5"
            [class.font-semibold]="locale.locale() === option.id"
            [class.text-[#3699FF]]="locale.locale() === option.id"
            [class.text-slate-700]="locale.locale() !== option.id"
            [class.dark:text-slate-200]="locale.locale() !== option.id"
          >
            <span class="flex items-center gap-2">
              <span class="text-base leading-none select-none" aria-hidden="true">{{
                option.flag
              }}</span>
              {{ option.label }}
            </span>
            @if (locale.locale() === option.id) {
              <svg
                class="h-4 w-4 shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            }
          </button>
        </li>
      }
    </ul>
  }
</div>
